module.exports = __webpack_public_path__ + "ImagemViradaTurno.png?1554e4e52b71dd4b7eacde00a7932928";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point/ImagemViradaTurno.png
// module id = 935
// module chunks = 0